module.exports = __webpack_public_path__ + "images/8fd96b494f126e5e861794e0bf352b76d2431aabbd708d3a9d0875a392f5973a.svg";